import { UiCardModel } from "../../models";

import { mockRouteModel, mockRouteModelContent } from "./mock-route";

export function mockUiCardModel({
    id = "Card-1234",
    type = "uiCard",
    locale = "en",
    content = mockUiCardModelContent()
}: Partial<UiCardModel> = {}): UiCardModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiCardModelContent = UiCardModel["content"];

export function mockUiCardModelContent({
    entryTitle = "Example Card",
    title = "Lorem ipsum",
    content = "Some card content goes here",
    route = mockRouteModel({
        content: mockRouteModelContent({ path: "#test" })
    }),
    ...optionals
}: Partial<UiCardModelContent> = {}): UiCardModelContent {
    return {
        entryTitle,
        title,
        content,
        route,
        ...optionals
    };
}
